import { render } from "./CardDetails.vue?vue&type=template&id=474889a1"
import script from "./CardDetails.vue?vue&type=script&lang=js"
export * from "./CardDetails.vue?vue&type=script&lang=js"
script.render = render

export default script